export interface FeatureConfigurationType {
  isHideQueryStringEnabled: boolean;
  isOldPromotionsActive: boolean;
  isAmbientLightEnabled: boolean;
  isTableConfigJspEnabled: boolean;
  isRestartControllerEnabled?: boolean;
  isBackToGameVideoEnabled?: boolean;
  streamDebug?: boolean;
}

const isProduction = process.env.NODE_ENV === 'production';

const initFeatureConfiguration = (): FeatureConfigurationType => {
  const searchParams = new URLSearchParams(window.location.search);

  const preserveUrlSession = searchParams.get('preserveUrlSession') === 'true';
  let isHideQueryStringEnabled: boolean;
  if (isProduction) {
    isHideQueryStringEnabled = !preserveUrlSession;
  } else {
    isHideQueryStringEnabled = false;
  }

  return {
    isHideQueryStringEnabled: isHideQueryStringEnabled,
    isOldPromotionsActive: true,
    isAmbientLightEnabled: searchParams.get('ambientLight') !== 'false',
    isTableConfigJspEnabled: searchParams.get('tableConfigJsp') !== 'false',
    isRestartControllerEnabled: searchParams.get('resetController') !== 'false',
    isBackToGameVideoEnabled: searchParams.get('backToGameVideo') === 'true',
    streamDebug: searchParams.get('streamDebug') === 'true',
  };
};

export const FeatureConfiguration = initFeatureConfiguration();
